/**
 * Significant Financial Interest is built, as of now, as an extension of Table. As a result, even though it doesn't
 * look like a table to a user, many table-related terms and constructs are used herein. This "table" is configured to
 * display "stacked", which takes the typically horizontally distributed columns and rotates their placement so as to
 * display vertically stacked.
 *
 * "Table"  = The collection of Significant Financial Interest "Relationships"
 * "Row"    = A "Relationship"
 * "Column" = A "Question"
 * "Cell"   = An instance of a Question
 */
define('view/form/significant.financial.interest.content.view',['require','exports','module','backbone','underscore','backbone.radio','uikit/uikit','formkit/view/form.object/content/table.content.view','redactor/redactor','uikit/extra/static.methods','formkit/behavior/answer.value.failed.validations.behavior','templates','model/provisional.organization.model','fukit','templates','fukit'],function(require, exports, module) {
  //prettier-ignore
  var Backbone                             = require('backbone'),
      _                                    = require('underscore'),
      Radio                                = require('backbone.radio'),
      UIKit                                = require('uikit/uikit'),
      TableContentView                     = require('formkit/view/form.object/content/table.content.view'),
      Redactor                             = require('redactor/redactor'),
      StaticMethods                        = require('uikit/extra/static.methods'),
      AnswerValueFailedValidationsBehavior = require('formkit/behavior/answer.value.failed.validations.behavior'),
      Templates                            = require('templates'),
      ProvisionalOrganizationModel         = require('model/provisional.organization.model'),
      disclosureChangeChannel              = Radio.channel('disclosureChangeChannel'),
      config                               = require('fukit').config,
      Templates                            = require('templates'),
      ConfirmInvokeMethodOnEventBehavior   = require('fukit').ConfirmInvokeMethodOnEventBehavior;

  // Would be an extension of TableContentView's SidebarContentView if that view were exposed.
  var SidebarContentView = UIKit.ItemView.extend({
    template: Templates.App['significant.financial.interest.object.settings.sidebar.content'],

    options: {
      designViewType: null,
      previewViewType: null,
      form: null,
      model: null,
    },

    internalViewOptions: {
      headerView: function() {
        return {
          type: UIKit.Header,
          text: 'Edit Question Settings',
          tagName: 'h4',
          color: 'primary',
        };
      },
      headerDividerView: function() {
        return {
          type: UIKit.Divider,
          section: true,
          visible: true,
        };
      },
      designDividerView: function() {
        return {
          type: UIKit.Divider,
          section: true,
          visible: true,
        };
      },
      previewLabelView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          bindings: {
            text: 'label',
          },
        };
      },
      previewTitleView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          bindings: {
            text: 'text',
          },
        };
      },
      previewDescriptionView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          renderAsHtml: true,
          color: 'muted',
          bindings: {
            text: 'description',
          },
        };
      },
      previewTitleRequiredQuestionView: function() {
        return {
          type: UIKit.Text,
          model: this.model,
          text: '*',
          color: 'red',
          bindings: {
            visible: 'required',
          },
        };
      },
      previewView: function() {
        return {
          type: this.getOption('previewViewType'),
          form: this.getOption('form'),
          model: this.model,
          // always true since sidebar is only used inside designer
          readonly: true,
        };
      },
      designView: function() {
        return {
          type: this.getOption('designViewType'),
          form: this.getOption('form'),
          model: this.model,
        };
      },
      requiredQuestionView: function() {
        return {
          type: UIKit.Checkbox,
          text: 'Make question required',
          model: this.model,
          bindings: {
            value: 'required',
          },
        };
      },
      doneButtonView: function() {
        return {
          type: UIKit.Button,
          className: UIKit.Button.prototype.className + ' right floated',
          color: 'primary',
          text: 'Done',
        };
      },

      descriptionView: function() {
        return {
          type: Redactor.RedactorView.extend({
            options: _.extend({}, Redactor.RedactorView.prototype.options, {
              buttons: ['bold', 'underline', 'italic', 'deleted', 'lists', 'link'],
            }),
          }),
          model: this.model,
          text: 'Description',
          bindings: {
            value: 'description',
          },
        };
      },
    },

    onFirstRender: function() {
      this.listenTo(
        this.requiredQuestionView,
        'change:value',
        _.debounce(function() {
          this.form.util.insertRequiredRule(this.model);
        })
      );
    },
  });

  var DesignAnswerItemView = TableContentView.DesignAnswerItemView.extend({
    internalViewOptions: TableContentView.DesignAnswerItemView.extendInternalViewOptions({
      numberInputView: function() {
        return {
          type: UIKit.Input,
          placeholder: 'No.',
          model: this.model,
          bindings: {
            value: 'label',
          },
        };
      },
    }),

    setupForm: function() {
      //this takes in the options passed by app/configuration/formkit.form.object.content.configuration.js
      if (this.model.get('custom') instanceof Backbone.Model && this.model.get('custom').get('mandatory')) {
        return;
      }
      var buttonContainerView = new UIKit.Container({
        className: 'ui buttons',
      });

      //This needed to be initialized for the settingsButtonView
      this.typeDropdownView = this.buildComponent({ name: 'typeDropdownView' });

      buttonContainerView.add((this.settingsButtonView = this.buildComponent({ name: 'settingsButtonView' })));
      buttonContainerView.add((this.addButtonView = this.buildComponent({ name: 'addButtonView' })));
      buttonContainerView.add((this.removeButtonView = this.buildComponent({ name: 'removeButtonView' })));

      this.formView
        .addGroup()
        .addField({ width: 2, text: '' }, this.buildComponent({ name: 'numberInputView' }))
        .parent()
        .addField({ width: 5, text: '' }, this.buildComponent({ name: 'labelInputView' }))
        .parent()
        .addField({ width: 4, text: '' }, this.buildComponent({ name: 'typeDropdownView' }))
        .parent()
        .addField({ width: 5 }, buttonContainerView)
        .parent();

      this.setupAddButtonView();
      this.setupRemoveButtonView();
      this.setupSettingsButtonView();
      this.setupTypeDropdownView();
    },

    getSidebarType: function() {
      var SidebarType = TableContentView.DesignAnswerItemView.prototype.getSidebarType.apply(this, arguments);

      SidebarType.prototype.internalViewOptions.contentView.type = SidebarContentView;

      return SidebarType;
    },

    setupTypeDropdownView: function() {
      var typeDropdownView = this.formView.typeDropdownView;

      this.listenTo(typeDropdownView, 'change:value', function() {
        var currentParent = this.form.util.parent(this.model);
        var currentIndex = this.form.util.indexOfChild(currentParent, this.model);
        this.form.insertTemplateObject(
          currentParent,
          {
            label: this.model.get('label'),
            text: this.model.get('text'),
            type: typeDropdownView.value,
          },
          currentIndex
        );
        this.form.detachTemplateObject(this.model);
      });
    },
  });

  var DesignAnswerCollectionView = TableContentView.DesignAnswerCollectionView.extend({
    childView: DesignAnswerItemView,
  });

  var DesignAnswerView = TableContentView.DesignAnswerView.extend({
    template: Templates.App['significant.financial.interest.object.design'],
    internalViewOptions: TableContentView.DesignAnswerView.extendInternalViewOptions({
      collectionView: function() {
        return {
          type: DesignAnswerCollectionView,
          templateObjectTypeCollection: this.templateObjectTypeCollection,
        };
      },
    }),

    modelEvents: {
      'remove:child': 'insertModelOnNearlyEmptyCollection',
    },
    //ensures admin always sees atleast 1 question in design area
    insertModelOnNearlyEmptyCollection: function() {
      if (this.form.util.childCount(this.model) === 1) {
        var childTemplateObject = this.form.getContentViewOption(
          this.form.getTemplateObjectTypeName(this.model),
          'childTemplateObject'
        );
        this.form.insertTemplateObject(this.model, childTemplateObject);
      }
    },
  });

  var SignificantFinancialInterestQuestionCellView = UIKit.Table.CellView.extend({
    template: Templates.App['significant.financial.interest.object.question.cell'],

    internalViewOptions: function() {
      var columnModel = this.getOption('columnModel');
      return UIKit.Table.CellView.extend({}, StaticMethods).extendInternalViewOptions({
        labelView: {
          type: UIKit.Text,
          className: 'previewLabel',
          model: columnModel,
          bindings: {
            text: 'label',
          },
        },
        titleView: {
          type: UIKit.Text,
          className: 'previewText',
          model: columnModel,
          bindings: {
            text: 'text',
          },
        },
        descriptionView: {
          type: UIKit.Text,
          className: 'previewDescription',
          color: 'muted',
          model: columnModel,
          renderAsHtml: true,
          bindings: {
            text: 'description',
          },
        },
        requiredQuestionView: {
          type: UIKit.Text,
          model: columnModel,
          color: 'red',
          text: '*',
          bindings: {
            visible: 'required',
          },
        },
      });
    },
  });

  var SignificantFinancialInterestRelationshipRowView = UIKit.Table.RowView.extend({
    childView: SignificantFinancialInterestQuestionCellView,
    childViewOptions: {
      className: function() {
        //toggles a divider based on whether multiple relationships are added
        return this.getOption('columnIndex') === 0 ? 'top-border-stacked-cell' : 'no-border-stacked-cell';
      },
    },
  });

  var SignificantFinancialInterestRelationshipsTableView = UIKit.Table.extend({
    childView: SignificantFinancialInterestRelationshipRowView,
  });

  var PreviewAnswerView = TableContentView.PreviewAnswerView.extend({
    template: Templates.App['significant.financial.interest.object.preview'],
    forceUpdate: {
      model: true,
      collection: true,
      visible: true
    },
    autofill: function() {
      var self = this;
      var sfiModel = this.model;
      var form = this.form;
      Radio.request('loadingService', 'startLoading');
      var sfiObjectName = sfiModel.get('text');
      form.getTemplateModel().clearUrlParams();
      form.getTemplateModel().urlParams({sfiObjectName: sfiObjectName});
      form.getTemplateModel().autofill({}, {
        success: function() {
         // COI-2030
          //self.onInjectedTableViewWithMinRows(); // new code

           self.onInjectedTableView(); // old code
          ///////////////
          Radio.request('loadingService', 'stopLoading');
        },
        error: function() {
          Radio.request('loadingService', 'stopLoading');
        }
      })
    },
    onFirstRender: function() {
      var self = this;
      var sfiModel = this.model;
      var editMode = config.get('answer.mode', true);

      if (!this.getOption('readonly') && editMode) {

        //autofill if there is no data here
        // There should be no data when:
        // 1. user is filling this out for the first time
        // 2. user made the form visible by changing other answers (handled by "change:displayed" listener" below)
        // 3. user deletes everything manually - this is an edge case, but the user should be hiding the SFI form by changing
        //    the answer from another conditional question.
        if(this.model.get('children').models[0].get('answer').get('data').length === 0){
          if (sfiModel.get("displayed")) {
            self.autofill();
          }
        }

        this.listenTo(sfiModel, 'change:displayed', function() {
          if (sfiModel.get("displayed")) {
             self.autofill();
          } else {
            //prevent deleting the same org twice quickly, which results in some weird backend errors
            var deletedOrgNames = {};
            self.tableView.children.forEach(function(childView) {
              //this calls "delete relationship" for all rows
              if(childView.columnViews){
                var deleteButtonView = childView.columnViews[0];
                var rowView = deleteButtonView;
                var externalOrg = rowView.model ? rowView.model.attributes.answers.models[0].attributes.value : {}
                if(externalOrg && deletedOrgNames[externalOrg.name] === undefined){
                  disclosureChangeChannel.trigger('sfi-external-org:removed', deleteButtonView);
                  deletedOrgNames[externalOrg.name] = true;
                }
                deleteButtonView.model.destroy();
              }
            });
          }
        });
      }


    },
    internalViewOptions: TableContentView.PreviewAnswerView.extendInternalViewOptions({
      tableView: function() {
        return {
          type: SignificantFinancialInterestRelationshipsTableView,
          className: 'ui table significant-financial-interest-relationships-table-view',
          collection: this.collection,
          headless: true,
        };
      },
      addRowButtonView: function() {
        return {
          type: UIKit.Button,
          icon: 'plus',
          size: 'small',
          color: 'primary',
          text: 'Add New Relationship',
        };
      },
    }),

    createTableViewColumnCollection: function() {
      var self = this;
      var DELETE_RELATIONSHIP_BUTTON_COLUMN = {
        collapsing: true,
        required: false,
        childView: UIKit.Button,
        childViewOptions: {
          text: 'Delete Relationship',
          icon: 'close',
          color: 'secondary',
          floated: 'right',
          disabled: this.getOption('readonly'),
          className: 'ui button delete-relationship',
          behaviors: {
            ConfirmInvokeMethodOnEventBehavior: {
              method: function() {
                disclosureChangeChannel.trigger('sfi-external-org:removed', this.view);
                this.view.model.destroy();
              },
              suppressModal: false,
              modalOptions: {
                closable: true,
                header: {
                  text: 'Removing Relationship',
                },
                content: {
                  icon: 'trash',
                  text: 'Are you sure you want to remove relationship from your disclosure? ' +
                    'You will have to re-enter information if you decide to re-add it later.',
                },
                actions: {
                  confirmButton: {
                    text: 'Remove',
                    color: 'red'
                  },
                },
              },
              behaviorClass: ConfirmInvokeMethodOnEventBehavior,
            },
          }
        },
        onBeforeAdd: function(childView) {
          childView.disabled = self.getOption('readonly');

          this.listenTo(self, 'change:readonly', function() {
            childView.disabled = self.getOption('readonly');
          });
        },
      };


      var ACCEPT_BUTTON_COLUMN = {
        collapsing: true,
        required: false,
        childView: UIKit.Button,
        childViewOptions: {
          text: 'Review & Accept',
          color: 'blue',
          floated: 'right',
          disabled: this.getOption('readonly'),
          className: 'ui button accept-relationship',
          addButtonCallback: function(childView) {

            childView.on('press', function() {

              var answers = childView.model.get("answers")
              answers.forEach(function(answerValueModel) {
                answerValueModel.set("autofillStatus", "completed");
                self.form.triggerEndEditAnswerEvent(self, answerValueModel.templateObjectModel, {
                  answerValueModel: answerValueModel,
                });
              });

              if (Radio.channel('notificationService')) {
                Radio.request('notificationService', 'showNotification', "Relationship has been Reviewed and Accepted");
              }

            });
          },
        },

        onBeforeAdd: function(childView) {
          var isAutofillPending = function(view) {
            return view.model.get("answers").any(function(answer) {
              return answer.get("autofillStatus") === "pending";
            })
          }

          // override/extend this getValidationMessage method.
          var superGetValidationMessage = self.form.util.getValidationMessage;
          self.form.util.getValidationMessage = function(failedValidation, templateObjectModel) {
            var message = superGetValidationMessage(failedValidation, templateObjectModel);
            if (message && message.trim() === "") {
              message = failedValidation.condition.message;
            }
            return message;
          };

          childView.disabled = self.getOption('readonly') || !isAutofillPending(childView);
          childView.visible = !(self.getOption('readonly') || !isAutofillPending(childView));

          this.listenTo(childView.model.get("answers"), 'change', function() {
            childView.disabled = self.getOption('readonly') || !isAutofillPending(childView)
            childView.visible = !(self.getOption('readonly') || !isAutofillPending(childView));
          });

          if (childView.childViewOptions) {
            childView.childViewOptions.addButtonCallback(childView);
          }

        },
      };

      var columns = this.model.get('children').map(function(templateObjectModel) {
        var column = this.createTableViewColumnModel(templateObjectModel);

        // remove all old listeners
        this.stopListening(templateObjectModel);

        // add new listeners
        this.listenTo(templateObjectModel, 'change:label', function() {
          column.set('label', templateObjectModel.get('label'));
        });

        this.listenTo(templateObjectModel, 'change:text', function() {
          column.set('text', templateObjectModel.get('text'));
        });

        this.listenTo(templateObjectModel, 'change:description', function() {
          column.set('description', templateObjectModel.get('description'));
        });

        this.listenTo(templateObjectModel, 'change:required', function() {
          column.set('required', templateObjectModel.get('required'));
        });

        return column;
      }, this);

      columns.unshift(ACCEPT_BUTTON_COLUMN);
      columns.unshift(DELETE_RELATIONSHIP_BUTTON_COLUMN);

      return columns;
    },
    createTableViewColumnModel: function(templateObjectModel) {
      var ContentView = this.getFormObjectContentViewType(templateObjectModel);
      var ContentViewPreviewAnswerView =
        ContentView.PreviewAnswerInsideTableView ||
        ContentView.PreviewAnswerView ||
        UIKit.ItemView.extend({ template: false });
      var tableContentView = this;

      var tableViewColumnModel = new Backbone.Model({
        text: templateObjectModel.get('text'),
        label: templateObjectModel.get('label'),
        description: templateObjectModel.get('description'),
        required: templateObjectModel.get('required'),
        childView: ContentViewPreviewAnswerView.extend({
          getAndLinkAnswerValueModel: function(model, form) {
            return form.getAnswerValueModel(model, this.getAnswerValueIndex());
          },
          getAnswerValueIndex: function() {
            var rowViewModel = this.getOption('rowView').model;
            return rowViewModel.collection.indexOf(rowViewModel);
          },
        }),

        childViewOptions: {
          // all table children are multi answer values
          isMultiAnswerValue: true,
          form: this.form,
          model: templateObjectModel,
          readonly: this.getOption('readonly'),
          formValidationMode: null,
        },

        onBeforeAdd: function(childView) {
          if (childView instanceof ContentViewPreviewAnswerView) {
            childView.readonly = tableContentView.getOption('readonly');
            this.listenTo(tableContentView, 'change:readonly', function() {
              childView.readonly = tableContentView.getOption('readonly');
            });
          }
        },

        behaviors: {
          AnswerValueFailedValidationsBehavior: {
            templateObjectModel: templateObjectModel,
            formObjectState: this.getOption('formObjectState'),
            form: this.getOption('form'),
            previewAnswerView: function() {
              return this.view.columnChildView;
            },
            onFailedVisibleValidations: function(failedVisibleValidations) {
              this.view.negative = failedVisibleValidations.length > 0;
            },
            behaviorClass: AnswerValueFailedValidationsBehavior,
          },
          removeExternalOrg: {
            behaviorClass: Mn.Behavior.extend({
              onFirstBeforeRender: function() {
                var disclosureModel = Radio.request('AppKit.resourceService', 'resource', 'disclosure');

                //prettier-ignore
                this.listenTo(disclosureChangeChannel, 'sfi-external-org:removed', function(childView) {
                  var rowView = childView.getOption('rowView');
                  var externalOrg = rowView.model ? rowView.model.attributes.answers.models[0].attributes.value : {}

                  console.log("Inside removeExternalOrg");
                  // COI-886 ExtOrg deleted when disclosure resolved:
                  // To avoid deleting twice - this gets triggered twice I don't know why
                  if (!externalOrg) {
                    console.log("Inside removeExternalOrg and !externalOrg");
                    // COI-1981: ExtOrgs are not removed
                    return;
                  }
                  rowView.model.get('answers').models[0].unset('value');
                  var orgModel = new ProvisionalOrganizationModel(externalOrg);

                  if (disclosureModel) {
                    orgModel.urlParams({ disclosureId: disclosureModel.get('id') });
                    orgModel.deleteExternalOrg();
                  }
                });
              },
            }),
          },
        },
      });

      return tableViewColumnModel;
    },
  });

  var SignificantFinancialInterestContentView = TableContentView.extend({
    internalViewOptions: TableContentView.extendInternalViewOptions({
      designAnswerView: function() {
        return {
          type: DesignAnswerView,
          templateObjectTypeCollection: this.getFilteredTemplateObjectTypeCollection(),
        };
      },
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView,
          collection: new Backbone.Collection(),
        };
      },
    }),

    getFilteredTemplateObjectTypeCollection: function() {
      var templateObjectTypeCollection = this.form.getTemplateObjectTypeCollection();

      return new Backbone.Collection(
        templateObjectTypeCollection.filter(function(templateObjectType) {
          return (
            templateObjectType.get('description') === 'External Org Finder' ||
            templateObjectType.get('isTableNestable') === true
          );
        }, this)
      );
    },
  });

  SignificantFinancialInterestContentView.DesignAnswerItemView = DesignAnswerItemView;
  SignificantFinancialInterestContentView.DesignAnswerCollectionView = DesignAnswerCollectionView;
  SignificantFinancialInterestContentView.DesignAnswerView = DesignAnswerView;
  SignificantFinancialInterestContentView.PreviewAnswerView = PreviewAnswerView;

  module.exports = SignificantFinancialInterestContentView;
});

